import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./scss/style.scss";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const AdminPanelLayout = React.lazy(() => import("./containers/AdminPanelLayout"));

// Pages
const Login = React.lazy(() =>
  import("./views/admin-panel/login/LoginIndex")
);
const ForgotPassword = React.lazy(() =>
  import("./views/admin-panel/forgot-password/ForgotPasswordIndex")
);
const ResetPassword = React.lazy(() =>
  import("./views/admin-panel/reset-password/ResetPasswordIndex")
);
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));

const App = () => {
  
    return (
      <BrowserRouter>
        <React.Suspense fallback={loading}>
            <Switch>
              <Route
                exact
                path="/Login"
                name="Login Page"
                render={(props) => <Login {...props} />}
              />
              <Route
                exact
                path="/forgot-password"
                name="Forgot Password"
                render={(props) => <ForgotPassword {...props} />}
              />
              <Route
                exact
                path="/ResetPassword"
                name="Reset Password"
                render={(props) => <ResetPassword {...props} />}
              />
              <Route
                exact
                path="/logout"
                name="Logout"
                render={(props) => <AdminPanelLayout {...props} />}
              />
              <Route
                exact
                path="/404"
                name="Page 404"
                render={(props) => <Page404 {...props} />}
              />
              <Route
                exact
                path="/500"
                name="Page 500"
                render={(props) => <Page500 {...props} />}
              />
              <Route
                path="/"
                name="Home"
                render={(props) => <AdminPanelLayout {...props} />}
              />
            </Switch>          
        </React.Suspense>
      </BrowserRouter>
    );
}

export default App;